import * as React from "react";
import {
  Scheduler,
  DayView,
  MonthView,
  WeekView,
  SchedulerItem,
  SchedulerSlotProps,
  SchedulerSlot,
} from "@progress/kendo-react-scheduler";
import "../../../assets/css/App.css";
import "../../../assets/css/Kendo.css";
import "./Scheduler.css";
import { FormWithAdditionalValidation, getTaskData } from "./SchedulerValidator";
import { CustomSlot, EditItemWithDynamicTitle } from "./CustomeTitle";
import { AvailabilitySchedulerTime, CandidateStatus } from "../AppConstants";
import _ from "lodash";
import auth from "../../Auth";
import { AppPermissions } from "../Constants/AppPermissions";

export interface SchedulerComponentProps {
  candidateId?: any;
  onChangeSelection?: any;
  modification: boolean;
  selection: boolean;
  selectedData?: any;
  initialData: any;
  createTask?: any;
  updateTask?: any;
  removeTask?: any;
  defaultDate?: any;
  handleSlotDoubleClick?: any;
}

export interface SchedulerComponentstate {
  candidateId: any;
  selectedData: any;
  selectedDeselectedValue: boolean;
  defaultDate: Date;
  selectedView?: any;

}

class SchedulerComponent extends React.Component<
  SchedulerComponentProps,
  SchedulerComponentstate
> {
  private defaultDate = new Date();
  constructor(props) {
    super(props);
    this.state = {
      candidateId: this.props.candidateId,
      selectedData: [],
      selectedDeselectedValue: false,
      defaultDate: new Date(),
      selectedView: "month",
    };
  }

  componentDidUpdate() {
   document.body.classList.remove("scheduler-shift-wrap");
  }
  
  componentWillUnmount() {
     document.body.classList.remove("scheduler-shift-wrap");
  }

  getScheduleId = (slotId) => {
    let ScheduleID = this.props.initialData.filter(
      (i) => JSON.parse(i.slot).id === slotId
    );
    if (ScheduleID.length > 0) {
      return ScheduleID[0].candAvalCalId;
    }
  };

  handleDataChange = ({ created, updated, deleted }) => {

    if (created.length > 0) {
      this.props.createTask(created);
    } else if (updated.length > 0) {
      this.props.updateTask(updated);
    } else if (deleted.length > 0) {
      this.props.removeTask(deleted);
    }
  };

  CustomItem = (props) => {
    const handleDoubleClick = (event) => {
      if (new Date(props.start) < new Date() || props.dataItem.title == CandidateStatus.ALLOCATED) {  
        event.syntheticEvent.preventDefault();
        return false;
      }

      if (!this.props.modification) {
        this.props.onChangeSelection(event);
      }

      event.syntheticEvent.preventDefault();
      if (props.onDoubleClick) {
        props.onDoubleClick(event);
      }
      document.body.classList.remove("scheduler-shift-wrap");
    };

    const handleClick = (event) => {
      if (!this.props.modification) {
        this.props.onChangeSelection(event);
      }

      event.syntheticEvent.preventDefault();
      if (props.onClick) {
        props.onClick(event);
      }
    };

    let taskId = this.getScheduleId(props.uid);
    let selected = [];

    if (!this.props.modification) {
      selected = this.props.selectedData.filter((i) => i === taskId);
    }

    const handleItemDrag = (event) => {
      if (props.dataItem.title == CandidateStatus.ALLOCATED) {
        return false;
      }
      else{
        if (props.onDrag) {
          props.onDrag(event);
        }
      }
    }

    return (
      <SchedulerItem
        {...props}
        editable={((new Date(props.start)) < new Date() || props.dataItem.title == CandidateStatus.ALLOCATED ) ? false : true}
        onClick={handleClick}
        onDrag={handleItemDrag}
        onDoubleClick={handleDoubleClick}
        style={{
          ...props.style,
          userSelect: "initial",
          color:
            selected.length > 0 && !this.props.modification
              ? "white"
              : this.props.modification && props.dataItem.title == CandidateStatus.AVAILABLE
                ? "white"
                : "black",
          backgroundColor:
            selected.length > 0 && props.dataItem.title == CandidateStatus.AVAILABLE && !this.props.modification
              ? "#2b70a5"
              : selected.length > 0 && props.dataItem.title == CandidateStatus.ALLOCATED && !this.props.modification
              ? "#cee890"
              : this.props.modification && props.dataItem.title == CandidateStatus.AVAILABLE
                ? "#2b70a5"
                : this.props.modification && props.dataItem.title == CandidateStatus.ALLOCATED
                ? "#cee890"
                : "#ffe69a",
        }}
        onRemoveClick={(event) => {
         props.onRemoveClick(event);
         document.body.classList.add("scheduler-shift-wrap");
        }}
      />
    );
  };

  CustomSlot = (props: SchedulerSlotProps) => {
  
    const handleDataChange = (event) => {
      event.syntheticEvent.preventDefault();    
    };

    const handleDoubleClick = (event) => {
      if(this.state.selectedView === 'month' )
      {
        this.props.handleSlotDoubleClick(event);
      }
      else if (props.onDoubleClick) {
        props.onDoubleClick(event);
      }
    }
  
    return new Date(props.start) < new Date() ? (
      <SchedulerSlot {...props} onDoubleClick={handleDataChange} style = {{backgroundColor:"#f1f1f1"}}/>
    ) : (
      <SchedulerSlot {...props} onDoubleClick={handleDoubleClick} style = {{cursor:"pointer", backgroundColor:"white"}}/>
    );
  };

  handleViewChange = (event) => {
    this.setState({selectedView: event.value});
  }
  
  render() {

    return (
      <Scheduler

        data={getTaskData(this.props.initialData)}
        item={this.CustomItem}
        onDataChange={this.handleDataChange}
        editable={{
          add: this.props.modification,
          remove: this.props.modification,
          drag: this.props.modification,
          resize: this.props.modification,
          edit: this.props.modification,
          select: this.props.selection,
        }}
        defaultDate={new Date(this.props.defaultDate)}
        form={FormWithAdditionalValidation}
        editItem={EditItemWithDynamicTitle}
        slot={this.CustomSlot}
        onViewChange={ this.handleViewChange}
      >
        <MonthView editable={auth.hasPermissionV2(AppPermissions.CANDIDATE_AVAILABILITY_CREATE) ? true : false} />
        <WeekView
          editable={auth.hasPermissionV2(AppPermissions.CANDIDATE_AVAILABILITY_CREATE) ? true : false}
          workDayStart={AvailabilitySchedulerTime.START_TIME}
          workDayEnd={AvailabilitySchedulerTime.END_TIME}
          slotDivisions={2}
        />

        <DayView
          editable={auth.hasPermissionV2(AppPermissions.CANDIDATE_AVAILABILITY_CREATE) ? true : false}
          workDayStart={AvailabilitySchedulerTime.START_TIME}
          workDayEnd={AvailabilitySchedulerTime.END_TIME}
        />
      </Scheduler>
    );
  }
}

export default SchedulerComponent;